import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderPrayVote from "../../../../src/content/pray-vote-engage/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderPrayVote,
  React
};